@if (loading) {
  <div class="inline-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading COI...</p>
  </div>
}

@if (!loading && !coi) {
  <div class="inline-empty">
    <mat-icon>verified_user</mat-icon>
    <p>COI not found</p>
  </div>
}

@if (!loading && coi) {
  <div class="inline-detail-container">

    <!-- Header -->
    <div class="inline-header">
      <div class="inline-header-info">
        <h3>
          <mat-icon>verified_user</mat-icon>
          Certificate of Insurance
        </h3>
        <div class="inline-metadata">
          <span class="meta-item">ID: {{ coi.coiId || 'N/A' }}</span>
          @if (coi.coiNum) {
            <span class="meta-separator">|</span>
            <span class="meta-item">Number: {{ coi.coiNum }}</span>
          }
          @if (coi.status) {
            <mat-chip-set>
              <mat-chip [highlighted]="coi.status === 'Active'">
                {{ coi.status }}
              </mat-chip>
            </mat-chip-set>
          }
        </div>
      </div>
      <div class="inline-header-actions">
        @if (document) {
          <button mat-stroked-button (click)="toggleDocument()">
            <mat-icon>{{ showDocument ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showDocument ? 'Hide' : 'View' }} Document
          </button>
        }
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Info Grid -->
    <div class="inline-info-grid">
      <div class="inline-info-field">
        <label>Party Providing COI</label>
        <div class="value">{{ partyProvidingCoiName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Insured Party</label>
        <div class="value">{{ insuredPartyName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Insurance Provider</label>
        <div class="value">{{ insuranceProviderName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Primary Owner</label>
        <div class="value">{{ primaryOwnerName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Effective Date</label>
        <div class="value">{{ formatDate(coi.effectiveDate) }}</div>
      </div>

      <div class="inline-info-field">
        <label>Expiration Date</label>
        <div class="value">{{ formatDate(coi.expirationDate) }}</div>
      </div>

      <div class="inline-info-field">
        <label>Execution Date</label>
        <div class="value">{{ formatDate(coi.executionDate) }}</div>
      </div>

      @if (coi.reviewPeriodInDays) {
        <div class="inline-info-field">
          <label>Review Period</label>
          <div class="value">{{ coi.reviewPeriodInDays }} days</div>
        </div>
      }

      @if (coi.coverageTypes && coi.coverageTypes.length > 0) {
        <div class="inline-info-field full-width">
          <label>Coverage Types</label>
          <div class="value">{{ coi.coverageTypes.join(', ') }}</div>
        </div>
      }

      <div class="inline-info-field">
        <label>Active COI</label>
        <div class="value">{{ coi.activeCoi ? 'Yes' : 'No' }}</div>
      </div>
    </div>

    <!-- Document Viewer -->
    @if (showDocument && document) {
      <mat-divider></mat-divider>
      <div class="inline-document-viewer">
        @if (document.isPdf || document.isImage || document.isOfficeDocument) {
          <iframe [src]="document.safeViewerUrl"
                  class="document-iframe"
                  [title]="document.fileName">
          </iframe>
        } @else {
          <div class="unsupported-file">
            <mat-icon>description</mat-icon>
            <p>Preview not available for this file type</p>
            <button mat-raised-button (click)="downloadDocument()">
              <mat-icon>download</mat-icon>
              Download
            </button>
          </div>
        }
      </div>
    }

  </div>
}
